import React from 'react';
import { motion } from 'framer-motion';
import { FaGlobe, FaRobot, FaMobileAlt, FaMicrochip, FaBrain, FaBroadcastTower } from 'react-icons/fa';

const services = [
  {
    icon: <FaGlobe className="text-cyan-400 w-8 h-8" />,
    title: 'Custom Website Development',
    desc: 'Modern, responsive websites tailored to your brand.',
  },
  {
    icon: <FaRobot className="text-cyan-400 w-8 h-8" />,
    title: 'AI Chatbot Development',
    desc: 'Conversational AI systems for customer engagement.',
  },
  {
    icon: <FaMobileAlt className="text-cyan-400 w-8 h-8" />,
    title: 'Mobile App Development',
    desc: 'Cross-platform apps with seamless performance.',
  },
  {
    icon: <FaMicrochip className="text-cyan-400 w-8 h-8" />,
    title: 'IoT & Embedded Systems',
    desc: 'Smart devices and embedded solutions.',
  },
  {
    icon: <FaBrain className="text-cyan-400 w-8 h-8" />,
    title: 'Custom AI Solutions',
    desc: 'Bespoke AI models for your business needs.',
  },
  {
    icon: <FaBroadcastTower className="text-cyan-400 w-8 h-8" />,
    title: 'Broadcasting & Streaming Platforms',
    desc: 'Real‑time communication infrastructures.',
  },
];

const Services = () => {
  return (
    <section id="services" className="py-20 px-6 bg-gray-900 text-gray-100">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto text-center mb-12"
      >
        <h2 className="text-3xl font-bold">Our Services</h2>
      </motion.div>
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {services.map((s, idx) => (
          <motion.div
            key={idx}
            whileHover={{ scale: 1.03 }}
            className="bg-gray-800 p-6 rounded-lg shadow-lg flex flex-col items-center text-center space-y-4"
          >
            {s.icon}
            <h3 className="text-xl font-semibold">{s.title}</h3>
            <p className="text-gray-300">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Services;
